import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Filter } from 'src/app/models/filters/filters';
import { AccountService } from 'src/app/services/account/account.service';
import { CalendarService } from 'src/app/services/calendar/calendar.service';

@Component({
  selector: 'app-calendar-filters',
  templateUrl: './calendar-filters.component.html',
  styleUrls: ['./calendar-filters.component.scss'],
})
export class CalendarFiltersComponent implements OnInit {
  filters: Array<Filter> = [];
  contextmenu: string;
  contextmenuX = 0;
  contextmenuY = 0;
  copiedElement;
  contextElement;
  searchValue: string;
  filterToDelete;
  constructor(
    private calendarService: CalendarService,
    private router: Router,
    public accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.getFilters();
  }

  getFilters() {
    this.calendarService.getFiltersFromAccount(this.accountService.vendor).subscribe((data) => {
      this.filters = data;
    });
  }

  editFilter(id) {
    this.router.navigate(['editCalendarFilter'], { queryParams: { id } });
  }

  deleteClone() {
    this.calendarService.deleteFilter(this.filterToDelete.id).subscribe(() => {
      this.getFilters();
    });
  }

  //activates the menu with the coordinates
  onrightClick(event, element?, project?) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    console.log('context menu', element);
    if (element) this.contextmenu = 'copy';
    else this.contextmenu = 'paste';
    this.contextElement = element;
    if (this.contextElement) {
      this.contextElement.vendor = localStorage.getItem('HechRomeoAccount');
      if (project) this.contextElement.project = true;
    }
  }

  disableContextMenu() {
    this.contextmenu = undefined;
  }
}
